<template>
  <div>
    <router-view />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useCategoryStore } from './stores/category';

const categoryStore = useCategoryStore();

function enhanceAccessibility() {
  // 1. Ant Design Checkbox 原生 input 補齊 title 與 aria-label (HM1130104C)
  const checkboxes = document.querySelectorAll('input.ant-checkbox-input');
  checkboxes.forEach((cb) => {
    if (!cb.getAttribute('title') || !cb.getAttribute('aria-label')) {
      const parentLabel = cb.closest('label');
      const labelText = parentLabel ? parentLabel.textContent.trim() : '';
      const text = labelText || '核取方塊';
      if (!cb.getAttribute('title')) cb.setAttribute('title', text);
      if (!cb.getAttribute('aria-label')) cb.setAttribute('aria-label', text);
    }
  });

  // 2. Ant Design Pagination 翻頁按鈕補齊按鈕角色名稱 (HM1410200C)
  const paginationLinks = document.querySelectorAll('.ant-pagination-item-link');
  paginationLinks.forEach((btn) => {
    if (!btn.getAttribute('aria-label')) {
      if (btn.querySelector('.anticon-left')) {
        btn.setAttribute('aria-label', '上一頁');
        btn.setAttribute('title', '上一頁');
      } else if (btn.querySelector('.anticon-right')) {
        btn.setAttribute('aria-label', '下一頁');
        btn.setAttribute('title', '下一頁');
      }
    }
  });

  // 3. 確保所有圖片皆具備 alt 屬性 (HM1110100C)
  const imgs = document.querySelectorAll('img:not([alt])');
  imgs.forEach((img) => {
    img.setAttribute('alt', '頁面相關圖片');
  });

  // 4. 確保頁面具備 #main-content 錨點且位於 Banner 之下（全域安全網）
  ensureMainContentAnchor();
}

function ensureMainContentAnchor() {
  if (document.getElementById('main-content')) return;

  const banner = document.querySelector(
    '.banner-area, .light-blue-banner, .faq-banner-area, .activities-area, .sitemap-banner, .carousel-container, .hero-section, header.sitemap-banner'
  );

  let insertTarget = null;
  let insertBefore = false;

  if (banner) {
    insertTarget = banner;
    insertBefore = false;
  } else {
    const content = document.querySelector('main, .main-content, .content, .content-container, .page-container, .register, .learning-page');
    if (content) {
      insertTarget = content;
      insertBefore = true;
    } else {
      const navbar = document.querySelector('nav, .navbar');
      if (navbar) {
        insertTarget = navbar;
        insertBefore = false;
      }
    }
  }

  if (insertTarget && insertTarget.parentNode) {
    const anchor = document.createElement('div');
    anchor.id = 'main-content';
    anchor.tabIndex = -1;
    anchor.className = 'main-content-anchor';
    anchor.innerHTML = '<a id="accesskey-c" href="#accesskey-c" accesskey="C" class="accesskey-brick sr-only-focusable" title="主要內容區塊，快捷鍵：Alt+C" aria-label="主要內容區塊">:::</a>';

    if (insertBefore) {
      insertTarget.parentNode.insertBefore(anchor, insertTarget);
    } else {
      insertTarget.parentNode.insertBefore(anchor, insertTarget.nextSibling);
    }
  }
}

onMounted(() => {
  categoryStore.fetchCategories();
  enhanceAccessibility();

  // 使用 MutationObserver 持續監控動態渲染的 DOM 元件
  const observer = new MutationObserver(() => {
    enhanceAccessibility();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
</script>

<style scoped>
</style>
